import { createContext, useContext, useState, type ReactNode } from 'react';

/**
 * Lets the portfolio page tell the header whether it is currently sitting over the hero
 * video (transparent, light text) or over page content (solid, dark text).
 */
type Chrome = { overHero: boolean; setOverHero: (v: boolean) => void };

const ChromeContext = createContext<Chrome>({ overHero: false, setOverHero: () => {} });

export function ChromeProvider({ children }: { children: ReactNode }) {
  const [overHero, setOverHero] = useState(false);
  return <ChromeContext value={{ overHero, setOverHero }}>{children}</ChromeContext>;
}

export const useChrome = () => useContext(ChromeContext);
